module.exports = __webpack_public_path__ + "static/media/side_4.cf34ee10.png";